"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "12",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "8",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "6",
    width: "12",
    height: "1",
    rx: "0.5"
  }));
};

exports["default"] = _default;